/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Of_Landing_Bubble_GreatInputs */

const en_of_landing_bubble_great = /** @type {(inputs: Of_Landing_Bubble_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Great work!`)
};

const id_of_landing_bubble_great = /** @type {(inputs: Of_Landing_Bubble_GreatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantap!`)
};

/**
* | output |
* | --- |
* | "Great work!" |
*
* @param {Of_Landing_Bubble_GreatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const of_landing_bubble_great = /** @type {((inputs?: Of_Landing_Bubble_GreatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Of_Landing_Bubble_GreatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_of_landing_bubble_great(inputs)
	return en_of_landing_bubble_great(inputs)
});